import { Component, Input, NgModule, OnInit } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConsts } from '@shared/AppConsts';
import { PhotoModalComponent } from '../photo-modal/photo-modal.component';

@Component({
  selector: 'kt-product-photo',
  templateUrl: './product-photo.component.html',
  styleUrls: ['./product-photo.component.scss']
})
export class ProductPhotoComponent implements OnInit {

  @Input()
  Width: number ;

  @Input()
  Height: number;

  @Input()
  ProductCode : string ;

  @Input()
  ProductName : string ;

  @Input()
  Style : string ;

  @Input()
  IsLarge : boolean ;

  productPhotoUrl : string = AppConsts.productImage.url + "/" ; //  'http://stokyonetimv2.transpop.com.tr/ProductImages/' ;
  bigSizeUrl = this.productPhotoUrl + "large/" ;

  constructor(
    private _modalService: NgbModal
  ) { }

  ngOnInit() {
    
   
    
    if (this.IsLarge == true){
      this.productPhotoUrl = this.productPhotoUrl + 'large/' + this.ProductCode + '.jpg';
    }
    else{
      this.productPhotoUrl = this.productPhotoUrl + this.ProductCode + '.jpg';
    }
    
  }

  onOpenModal(){
    var refPhotoModal = this._modalService.open(PhotoModalComponent, {
			size: 'md'
    });
    
    refPhotoModal.componentInstance.title = this.ProductName ;
    refPhotoModal.componentInstance.subTitle = this.ProductCode ;
    refPhotoModal.componentInstance.photoUrl = this.bigSizeUrl + this.ProductCode + '.jpg';
  }

}
